import { FacilityAutocomplete } from '../inputs';

const handleReportFacilityChange = (selection, setReportFacility) => {
	if (selection?.id) {
		setReportFacility({
			id: selection.id,
			facilityName: selection.facilityName,
			facilityNumber: selection.facilityNumber,
		});
		return;
	}
	setReportFacility({
		id: null,
		facilityName: null,
		facilityNumber: null,
		organizationId: null,
	});
};

export const FacilitySearch = (props) => {
	const { reportFacility, setReportFacility } = props;
	return (
		<div style={{ width: '400px' }}>
			<h3 style={{ marginBottom: '1rem' }}>Search Facility Name or Facility Number</h3>
			<FacilityAutocomplete
				disabled={false}
				facilityId={reportFacility?.id}
				facilityName={reportFacility?.facilityName}
				facilityNumber={reportFacility?.facilityNumber}
				onChange={(selection) => handleReportFacilityChange(selection, setReportFacility)}
				disableClearable
			/>
			{reportFacility?.facilityName && reportFacility?.facilityNumber && (
				<h2 style={{ marginTop: '2rem' }}>
					{reportFacility.facilityName} ({reportFacility.facilityNumber})
				</h2>
			)}
		</div>
	);
};
